import React from 'react';
import { useRouter } from 'next/router';
import FiltersContextProvider from '@/creditflowresearch/application/FiltersContext';
import InventoryTableContextProvider from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import BwicTableContextProvider from '@/creditflowresearch/application/Bonds/BwicTableContext';
import BondsAssetClassesContextProvider from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import useMappedSectors from '@/creditflowresearch/application/HeaderMenu/useMappedSectors';
import { defaultTileFilterPayload } from './constants';
import { BondsFiltersContextProvider } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';
import BondsTileTabContextProvider from '@/creditflowresearch/application/Bonds/BondsTileTabContext';

export const ComposeBondsTileContext = (props) => {
  const sectorsList = useMappedSectors();
  const { query: { sector } }:{ query: IQueryParams } = useRouter();
  const sectorItem = sectorsList[sector];
  const {
    bondTileData: {
      currentUserDataByFilter,
      filterPayload,
   },
  } = props;
  const { ...baseParams } = defaultTileFilterPayload;
  const bwicData = { bwics: currentUserDataByFilter.bwic };
  const inventoriesData = { inventories: currentUserDataByFilter.inventory };

  return (
    <BondsAssetClassesContextProvider>
      <BondsFiltersContextProvider initialFilter={ filterPayload.filter }>
        <FiltersContextProvider initial={ { baseParams } } sectorItem={ sectorItem }>
          <InventoryTableContextProvider
            isTile
            initial={ inventoriesData }
          >
            <BwicTableContextProvider
              isTile
              initial={ bwicData }
            >
              <BondsTileTabContextProvider>
                { props.children }
              </BondsTileTabContextProvider>
            </BwicTableContextProvider>
          </InventoryTableContextProvider>
        </FiltersContextProvider>
      </BondsFiltersContextProvider>
    </BondsAssetClassesContextProvider>
  );
};
